import { getAccount, getUser } from "@hardware/Store/Context/ContextSelectors";
import getAccountManagerInfo from "@hardware/Store/Handlers/MyAccount/GetAccountManager";
import { mediaQueriesBP } from "@hardware/Utilities/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconProps } from "@insite/mobius/Icon";
import Mail from "@insite/mobius/Icons/Mail";
import Phone from "@insite/mobius/Icons/Phone";
import Img from "@insite/mobius/Img";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    title = "Account Manager",
    userTitle = "User Info",
    ctaSendMessages = "Send Message",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const { isAuthenticated } = getSession(state);
    return {
        showAccountNumber: isAuthenticated,
        account: getAccount(state),
        user: getUser(state),
        billtoId: state.context.session.billToId,
    };
};

const mapDispatchToProps = {
    getAccountManagerInfo,
};

export type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface AccountManagerStyles {
    title?: TypographyProps;
    userTitle?: TypographyProps;
    container?: GridContainerProps;
    innerWrapper?: GridItemProps;
    innerUserWrapper?: GridItemProps;
    innerCustomerWrapper?: GridItemProps;
    imageWrapper?: InjectableCss;
    name?: TypographyProps;
    userName?: TypographyProps;
    userEmail?: TypographyProps;
    icon?: IconProps;
    link?: LinkPresentationProps;
    sendMessage: InjectableCss;
    imageSalesWrapper: InjectableCss;
    innerImageWrapper?: GridItemProps;
    imageSalesUserWrapper: InjectableCss;
}

export const accountManagerStyles: AccountManagerStyles = {
    title: {
        variant: "h3",
        css: css`
            display: block;
            margin-top: 10px;
            font-family: inherit;
            font-size: 1.2em;
            margin-bottom: 0;
            color: inherit;
        `,
    },
    userTitle: {
        variant: "h3",
        css: css`
            display: block;
            margin-top: 10px;
            font-family: inherit;
            font-size: 1.2em;
            margin-bottom: 0;
            color: inherit;
        `,
    },
    container: {
        gap: 0,
    },

    innerWrapper: {
        width: 12,
        css: css`
            display: flex;
            flex-direction: column;
            padding: 1rem 1rem 0 0;
            max-width: 260px;

            ${mediaQueriesBP.maxMD} {
                max-width: 100%;
            }
        `,
    },
    innerCustomerWrapper: {
        width: 12,
        css: css`
            display: flex;
            flex-direction: column;
            padding: 1rem 1rem 0 0;
            max-width: 260px;
            margin: auto !important;

            ${mediaQueriesBP.maxMD} {
                max-width: 100%;
            }
        `,
    },
    innerImageWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 10px !important;
            max-width: none !important;
            flex-basis: auto !important;

            ${mediaQueriesBP.maxMD} {
                max-width: 100%;
            }
        `,
    },

    innerUserWrapper: {
        width: 12,
        css: css`
            display: flex;
            flex-direction: column;
            padding: 1rem 1rem 0 0;
            max-width: 260px;

            ${mediaQueriesBP.maxMD} {
                max-width: 100%;
            }
        `,
    },
    imageWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            margin-bottom: 20px;
            height: 120px;
            width: 120px;
            border-radius: 8px;
            overflow: hidden;

            img {
                width: 100%;
                height: auto;
            }
        `,
    },
    imageSalesWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            border-radius: 8px;
            overflow: hidden;

            img {
                width: 100%;
                height: auto;
            }
        `,
    },
    imageSalesUserWrapper: {
        css: css`
            flex: 0 0 45px;
            width: 45px;
            height: 45px;
            border-radius: 50%;
            overflow: hidden;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.21);
            font-size: 0;
            margin-right: 15px !important;

            img {
                width: 100%;
                height: auto;
            }
        `,
    },
    icon: {
        css: css`
            margin-right: 8px;
            svg {
                fill: #094e66;
                margin-right: 8px;
                stroke: #fff;
            }
        `,
    },

    name: {
        css: css`
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            color: #36424a;
            font-size: 16px;
            font-weight: 700;
            word-break: break-word;
        `,
    },
    userName: {
        css: css`
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            color: #36424a;
            font-size: 16px;
            word-break: break-word;
        `,
    },

    userEmail: {
        css: css`
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            color: #282324 !important;
            font-size: 16px;
        `,
    },

    link: {
        css: css`
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            color: #282324 !important;
            font-size: 14px;
        `,
    },
    sendMessage: {
        css: css`
            text-transform: uppercase;
            display: inline-block;
            margin-bottom: 10px;
            font-size: 15px;
            font-weight: 700;
            color: #094e66;

            & span:hover {
                text-decoration: underline;
            }
        `,
    },
};

export const styles = accountManagerStyles;

export const AccountNumber = ({ getAccountManagerInfo, account, billtoId, user }: Props) => {
    const [accountManagerInfo, setAccountManagerInfo] = useState({}) as any;
    const fullName = `${user.firstName} ${user.lastName}`;

    useEffect(() => {
        if (!billtoId) {
            return;
        }

        getAccountManagerInfo({
            customerId: billtoId || "",
            onSuccess: result => {},
            onComplete: result => {
                if (result.apiResult) {
                    setAccountManagerInfo(result.apiResult.SalesPerson);
                }
            },
        });
    }, [account]);

    if (!accountManagerInfo || !user) {
        return null;
    }

    return (
        <>
            <GridContainer {...styles.container}>
                <GridItem {...styles.innerCustomerWrapper}>
                    {accountManagerInfo.CustomerLogoImagePath && (
                        <StyledWrapper {...styles.imageSalesWrapper}>
                            <Img src={accountManagerInfo.CustomerLogoImagePath} />
                        </StyledWrapper>
                    )}
                </GridItem>
            </GridContainer>
            <Typography {...styles.title}>{fields.userTitle}</Typography>
            <GridContainer {...styles.container}>
                <GridItem {...styles.innerUserWrapper}>
                    {user.email && <Typography {...styles.userEmail}>{user.email}</Typography>}
                    {fullName && <Typography {...styles.userName}>{fullName}</Typography>}
                    {typeof account !== "string" && account.companyName && (
                        <Typography {...styles.userName}>{account.companyName}</Typography>
                    )}
                </GridItem>
            </GridContainer>
            <Typography {...styles.title}>{fields.title}</Typography>
            <GridContainer {...styles.container}>
                <GridItem {...styles.innerImageWrapper}>
                    {accountManagerInfo.ImagePath && (
                        <StyledWrapper {...styles.imageSalesUserWrapper}>
                            <Img src={accountManagerInfo.ImagePath} />
                        </StyledWrapper>
                    )}
                    {accountManagerInfo.Name && <Typography {...styles.name}>{accountManagerInfo.Name}</Typography>}
                </GridItem>
                <GridItem {...styles.innerWrapper}>
                    {accountManagerInfo.Email && (
                        <Typography {...styles.link}>
                            <Icon {...styles.icon} src={Mail} />
                            {accountManagerInfo.Email}
                        </Typography>
                    )}
                    {accountManagerInfo.Phone1 && (
                        <Typography {...styles.link}>
                            <Icon {...styles.icon} src={Phone} />
                            {accountManagerInfo.Phone1}
                        </Typography>
                    )}
                    {accountManagerInfo.Phone2 && (
                        <Typography {...styles.link}>
                            <Icon {...styles.icon} src={Phone} />
                            {accountManagerInfo.Phone2}
                        </Typography>
                    )}
                    {accountManagerInfo.Email && (
                        <Link {...styles.sendMessage} href={`mailto:${accountManagerInfo.Email}`}>
                            {fields.ctaSendMessages}
                        </Link>
                    )}
                </GridItem>
            </GridContainer>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AccountNumber) as any,
    definition: {
        allowedContexts: ["MyAccountPage"],
        group: "My Account",
        displayName: "Account Navigation Profile",
        fieldDefinitions: [
            {
                name: "My Account Manager",
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "My Account Manager",
                fieldType: "Translatable",
                sortOrder: 1,
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
